import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JsonSchemaExamplePageComponent } from './json-schema-example-page/json-schema-example-page.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { EgiRoutes } from '@ervo/page-framework';
import { UserModule } from '@/app/platform/platform-core/user/user.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

const topic = 'Voorbeelden';

@NgModule({
  declarations: [JsonSchemaExamplePageComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgSelectModule,
    UserModule,
    DragDropModule
  ]
})
export class ExamplePagesModule {
  static readonly routes: EgiRoutes = [
    {
      path: 'json-schema-form',
      component: JsonSchemaExamplePageComponent,
      data: {
        config: {
          name: 'Json schema',
          topic,
          id: '67abb90e-4427-4d7b-a418-eaffcff89f72',
          clickTroughPages: {},
          dependencies: {},
          features: {}
        }
      }
    }
  ];
}
